const projects_items = [
  {
    id: 35,
    title: "Product Research AI - SaaS AI Website",
    category: "WordPress Development",
    tags: [
      "WordPress",
      "Beaver Builder",
      "AI Integration",
      "SaaS",
      "Subscription",
    ],
    live_link: "https://productresearch.ai/",
    github_link: "",
    color: "#4a69bd",
    date: "28 December 2023",
    desc: `
      <h2>Project Overview</h2>
      <div class='py-4'>
        <strong>Website:</strong> <a href='https://productresearch.ai/' target='_blank'>ProductResearch.ai</a><br/>
        <strong>Platform:</strong> WordPress with custom Beaver Builder modules<br>
      </div>
      <p>Product Research AI is a sophisticated SaaS platform that leverages AI to transform e-commerce product research. This platform integrates seamlessly with OpenAI to deliver innovative, AI-powered tools for e-commerce success.</p>
      
      <h2>SaaS Concept</h2>
      <p>This project utilizes a SaaS model to provide subscription-based access to tools that enhance e-commerce operations, emphasizing scalability, continuous improvement, and real-time data processing.</p>
  
      <h2>My Role</h2>
      <p>As the developer, I was tasked with:</p>
    <ul>
        <li>Designing the full website with a SaaS model</li>
        <li>Implement payment gateway for subscription-based services</li>
        <li>Developing custom Beaver Builder modules to enhance the platform's functionality, tailored specifically for AI integrations.</li>
        <li>Integrating OpenAI API as a custom Beaver Builder addon, enabling advanced AI features</li>
        <li>Implementing server-side rendered (SSR) content to guarantee optimal performance and real-time updates, ensuring a seamless user experience.</li>
      </ul>
  
      <h2>Key Features</h2>
      <ul>
        <li><strong>AI-Driven Product Research:</strong> Utilizes OpenAI to perform deep and insightful product analysis.</li>
        <li><strong>KPI Calculator:</strong> Automatically computes key performance indicators to aid strategic planning.</li>
        <li><strong>Product Copy Generation:</strong> AI-powered tool to generate compelling product descriptions (Coming Soon).</li>
        <li><strong>Customer Persona Development:</strong> Sophisticated AI to craft detailed customer profiles (Upcoming Feature).</li>
        <li><strong>AI-Enhanced Facebook Ad Copy:</strong> Generates optimized ad content for social media marketing (Future Addition).</li>
        <li><strong>Niche Ideas, Winning Product Generator, and Google Ad Copy:</strong> Provides tools to find niche ideas, discover winning products, and create Google ad copy.</li>
        <li><strong>Problem/Solution and Barrier Solver:</strong> Features to address common e-commerce challenges (Coming Soon).</li>
        <li><strong>Profit & Cost Tracking:</strong> Tools to monitor and manage finances effectively (Coming Soon).</li>
        <li><strong>Telegram Community:</strong> A platform for users to engage and share insights.</li>
        <li><strong>Manage Subscription:</strong> Allows users to manage their SaaS subscriptions seamlessly.</li>
      </ul>

      <h2>Screenshots</h2>
      <div class='screenshots'>
          <img src='/assets/images/projects/productresearchai/product-research-ai-1.png' alt='Dashboard Overview'>
          <img src='/assets/images/projects/productresearchai/product-research-ai-2.png' alt='KPI Calculator Interface'>
          <img src='/assets/images/projects/productresearchai/product-research-ai-3.png' alt='Product Research Tool'>
          <img src='/assets/images/projects/productresearchai/product-research-ai-4.png' alt='Customer Persona Builder'>
          <img src='/assets/images/projects/productresearchai/product-research-ai-5.png' alt='Facebook Ad Creator'>
          <img src='/assets/images/projects/productresearchai/product-research-ai-6.png' alt='Product Description Generator'>
      </div>
  
      <h2>Outcome and Impact</h2>
      <p>Since its launch, Product Research AI has significantly enhanced the efficiency and productivity of e-commerce businesses, providing powerful AI tools that improve decision-making and operational efficiencies, leading to increased sales.</p>
    `,
    img: require("@/assets/images/projects/product-research-ai-sass.webp"),
  },

  {
    id: 40,
    title: "NapTech Games - Company's Parent Website",
    category: "Laravel",
    tags: ["Laravel", "Speed Optimization", "AI Content"],
    live_link: "https://naptechgames.com/",
    github_link: "",
    color: "#008a00",
    date: "01 January 2023 - ∞",
    desc: `
      <h2>Project Overview</h2>
      <p>NapTechgames serves as the cornerstone for a leading gaming company, offering an extensive array of games and resources to a global audience. When I joined the company, the website was significantly underperforming in speed, even with the use of paid Cloudflare services.</p>
      
      <h2>Challenges and Solutions</h2>
      <p>Upon diagnosing the performance issues, I discovered that image load times were a major bottleneck due to the site hosting over 45,000 images. My solution involved:</p>
      <ul>
        <li>Implementing advanced image optimization techniques using Laravel to significantly reduce file sizes without compromising quality.</li>
        <li>Refactoring backend code and database queries to enhance overall site responsiveness and efficiency.</li>
        <li>Integrating caching mechanisms that further decreased load times and server demand.</li>
      </ul>
      
      <h2>My Role</h2>
      <p>As a Laravel developer, my responsibilities extended beyond just optimizing the site:</p>
      <ul>
        <li>Developing and maintaining APIs for Android and iOS applications, ensuring seamless game data synchronization across platforms.</li>
        <li>Providing game data to partner companies via robust APIs, facilitating a wider distribution and accessibility of games.</li>
        <li>Generating engaging and fresh game content for over 45,000 games using AI-driven tools, keeping the platform vibrant and updated.</li>
        <li>Regularly updating the site’s security measures to safeguard against new vulnerabilities and ensuring compliance with the latest safety standards.</li>
      </ul>

    

      <h2>Outcome and Impact</h2>
      <p>The enhancements I implemented led to a 60% improvement in site speed, drastically improving user experience and engagement. The website now supports high traffic volumes with optimized performance and continues to serve as a dynamic platform for gaming enthusiasts worldwide.</p>
    `,
    img: require("@/assets/images/projects/naptechgames.webp"),
  },
  {
    id: 42,
    title: "Tournament Xoss Games",
    category: "Laravel",
    tags: ["DOB Payment Gateway", "Laravel", "Management System"],
    live_link: "https://tournament.xoss.games/",
    github_link: "",
    color: "#808ae4",
    date: "01 January 2023 - ∞",
    desc: `
      <h2>Project Overview</h2>
      <p>Tournament Xoss Games is a specialized platform designed for managing gaming tournaments. My role involves overseeing the maintenance and continual improvement of the tournament management system, ensuring it operates smoothly and meets the high standards expected by our users.</p>

      <h2>Responsibilities</h2>
      <p>My responsibilities encompass maintaining system stability and implementing updates:</p>
      <ul>
        <li><strong>System Management:</strong> Regular updates and maintenance of the tournament system to ensure optimal performance and uptime.</li>
        <li><strong>Bug Resolution:</strong> Proactively identifying and resolving issues to prevent disruptions during tournaments.</li>
        <li><strong>Feature Updates:</strong> Implementing new features and updates as required, improving system functionality and user experience.</li>
         <li><strong>Enhanced Tournament Management:</strong> A full-featured backend to manage tournaments, including scheduling, participant tracking, and real-time updates.</li>
          <li><strong>System Optimization:</strong> Applied coding-level optimizations to enhance the system's performance significantly, improving load times and user interactions by 60%.</li>
      </ul>

      <h2>Project Challenges</h2>
      <p>Working closely with GP Bangladesh and its parent company Telenor, I manage the integration of the Direct Operator Billing (DOB) payment system, enhancing the security and efficiency of user transactions.</p>

      <h2>Key Features</h2>
      <ul>
        <li><strong>Secure Transaction Processing:</strong> Management of the DOB payment gateway to ensure secure and reliable billing.</li>
        <li><strong>Enhanced User Experience:</strong> Ongoing optimizations to improve user engagement and system responsiveness.</li>
        <li><strong>Comprehensive Tournament Control:</strong> Updated tools and features that allow for efficient management of all aspects of gaming tournaments.</li>
      </ul>

      <h2>Outcome and Impact</h2>
      <p>The enhancements and diligent management of the Tournament Xoss Games platform have significantly improved its functionality and reliability, leading to increased user satisfaction and a growing reputation as a top-tier platform for competitive gaming.</p>
    `,
    img: require("@/assets/images/projects/tournament-xoss-games.webp"),
  },

  {
    id: 44,
    title: "ShahelaTrading - ERP Solution",
    category: "Laravel",
    tags: ["ERP", "Laravel", "Inventory Management", "Sales Management"],
    live_link: "https://shahelatrading.com",
    github_link: "",
    color: "#91d1f0",
    date: "01 January 2023 - ∞",
    desc: `
      <h2>Project Overview</h2>
      <p>ShahelaTrading ERP is a sophisticated enterprise resource planning system tailored for comprehensive inventory and sales management. Developed using Laravel, this ERP solution supports a variety of business processes, enhancing efficiency and facilitating growth.</p>
      <h2>My Role and Responsibilities</h2>
      <p>As a developer, my responsibilities extend beyond mere coding to managing the ERP system's day-to-day operations and implementing new functionalities:</p>
      <ul>
        <li><strong>System Enhancement:</strong> Developing new features such as sales return processing, advanced payment options, and supply chain improvements.</li>
        <li><strong>Financial Operations:</strong> Integrating tools for managing bank checks and generating financial reports, including PDF invoices and sales returns.</li>
        <li><strong>Support and Maintenance:</strong> Providing continuous support and routine maintenance to ensure the system operates seamlessly and stays updated with the latest technological advances.</li>
        <li><strong>Documentation and Reporting:</strong> Creating detailed documentation and reports to support business decisions and operational transparency.</li>
      </ul>
      
      <h2>Outcome and Impact</h2>
      <p>The enhancements I have implemented have significantly improved the functionality and efficiency of the ERP system at ShahelaTrading. The system is now equipped with advanced tools that support dynamic business needs, leading to improved financial management and operational efficiency.</p>
    `,
    img: require("@/assets/images/projects/erp-1.webp"),
  },
];

const projects = projects_items.map((project) => {
  const title = project.title.replace(/ /g, "-").toLowerCase();
  const permalink = title;
  return {
    ...project,
    permalink,
  };
});

export default projects;
